import {
  FormDefinitionContent,
  FormDefinitionField,
  FormDefinitionSection,
} from 'forms/form-designer/Constants';

/**
 * Given a form definition's content, iterate through and get all the form fields. The order will be as if the
 * form was flattened to have no sections.
 * @param formDefinitionContent
 * @returns
 */
export function gatherFormFieldsFromDefinitionContent(
  formDefinitionContent: FormDefinitionContent
): Array<FormDefinitionField> {
  const sectionContentStack = formDefinitionContent.sections.flatMap(({content}) => content);
  const formFields: Array<FormDefinitionField> = [];
  while (sectionContentStack.length) {
    const sectionOrField = sectionContentStack.shift()!;
    // if it has content, it must be a section
    // eslint-disable-next-line benchlint/no-in-operator
    if ('content' in sectionOrField) {
      const section = sectionOrField;
      sectionContentStack.unshift(...section.content);
    } else {
      const field = sectionOrField;
      formFields.push(field);
    }
  }
  return formFields;
}

/** Returns true when a section should be displayed, because it's not empty (has a name, description, or field) */
export function shouldDisplaySection(section: FormDefinitionSection): boolean {
  return Boolean(section.content.length || (section.isNameVisible && section.name) || section.description);
}
